export default "__VITE_ASSET__NxEu6ZP8__"